export default {
  'demo-info-bar.exercises': 'Onder het tabje Codeer vind je ingevulde Scratch oefeningen in klas 2LA1.',
  'demo-info-bar.exams': 'Je bevindt je op dit moment in de FTRPRF demo omgeving. Ingevulde toetsen vind je terug onder Computationeel denken en denken met een kritische geest, in de klas 2LA1.',
  'demo-info-bar.general': 'Je bevindt je op dit moment in de FTRPRF demo omgeving. Wil je onze lessen ook met je eigen klassen bekijken, dan kan je contact opnemen met juul@ftrprf.be',
};
